import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import { useTranslation } from 'react-i18next';
import IframeDocxPreview from './IframeDocxPreview';
import { imageUrl } from '../../../../../Components/helper';

const MODAL_CLASS_NAMES = 'relative-width-modal custom-modal modal-medium';
const MODAL_SIZE = 'lg';
const MODAL_BACKDROP = 'static';
const MODAL_CENTERED = true;

function PreviewModal({ onOpen, toggle, data }) {
  const [state, setState] = useState([]);
  const { t } = useTranslation('common');
  const fileExtension = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  const imageTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
  const isImageType = imageTypes.includes(data?.mimeType);

  useEffect(() => {
    if (data?.mimeType === fileExtension) {
      const fetchExcelData = async () => {
        try {
          let fileUrl = data?.path;
          if (fileUrl?.includes('static')) {
            fileUrl = `${imageUrl}${data?.path.split('static')[1]}`;
          }
          const response = await fetch(fileUrl);

          const arrayBuffer = await response.arrayBuffer();
          const blob = new Blob([arrayBuffer], { type: fileExtension });

          const reader = new FileReader();

          reader.onload = (event) => {
            const binaryString = event.target.result;
            const workbook = XLSX.read(binaryString, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const excelData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
            setState(excelData);
          };

          reader.readAsBinaryString(blob);
        } catch (error) {
          // Error fetching or parsing the file
        }
      };

      fetchExcelData();
    }
  }, [data?.path, data?.mimeType, data?.fromProductPurchaseOrder, data]);

  return (
    <>
      {data?.mimeType === fileExtension && (
        <Modal className={MODAL_CLASS_NAMES} size={MODAL_SIZE} show={onOpen} onHide={toggle} backdrop={MODAL_BACKDROP} centered={MODAL_CENTERED}>
          <Modal.Header>
            {data?.fileName}
            <button type="button" className="close" onClick={toggle} aria-label={t('COMMON_LABEL.CLOSE')}>
              <i className="icon-close" />
            </button>
          </Modal.Header>
          <Modal.Body className="px-5">
            {!data && <div className="text-center">{t('EDIT_FIELD_MODAL.NO_PREVIEW')}</div>}
            {state.length > 0 && (
              <>
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead className="thead-dark">
                      <tr>
                        {Object.keys(state[0]).map((key) => (
                          <th key={key}>{key}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {state.map((row, index) => (
                        <tr key={`row-${index}`}>
                          {Object.values(row).map((cell, cellIndex) => (
                            <td key={`cell-${index}-${cellIndex}`}>{cell}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="text-right mt-3">
                  <button className="btn btn-default" type="button" onClick={() => toggle()}>
                    {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PREVIEW_MODAL.CLOSE')}
                  </button>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>
      )}

      {isImageType && (
        <Modal className={MODAL_CLASS_NAMES} size={MODAL_SIZE} show={onOpen} onHide={toggle} backdrop={MODAL_BACKDROP} centered={MODAL_CENTERED}>
          <Modal.Header>
            {data?.fileName}
            <button type="button" className="close" onClick={toggle} aria-label={t('COMMON_LABEL.CLOSE')}>
              <i className="icon-close" />
            </button>
          </Modal.Header>
          <Modal.Body className="px-5 text-center">
            {!data && <div className="text-center">{t('EDIT_FIELD_MODAL.NO_PREVIEW')}</div>}
            {data?.path && (
              <img src={data.path} alt={data?.fileName || 'Preview'} className="img-fluid max-h-80" style={{ maxHeight: '80vh', objectFit: 'contain' }} />
            )}
            <div className="modal-buttons mt-2 d-flex justify-content-between">
              <button className="btn btn-default" type="button" onClick={() => toggle()}>
                {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PREVIEW_MODAL.CLOSE')}
              </button>
            </div>
          </Modal.Body>
        </Modal>
      )}
      {data?.mimeType !== fileExtension && data?.mimeType !== 'application/msword' && !isImageType && (
        <Modal className={MODAL_CLASS_NAMES} size={MODAL_SIZE} show={onOpen} onHide={toggle} backdrop={MODAL_BACKDROP} centered={MODAL_CENTERED}>
          <Modal.Header>
            {data?.fileName}
            <button type="button" className="close" onClick={toggle} aria-label={t('COMMON_LABEL.CLOSE')}>
              <i className="icon-close" />
            </button>
          </Modal.Header>
          <Modal.Body className="px-5">
            {!data && <div className=" text-center">{t('EDIT_FIELD_MODAL.NO_PREVIEW')}</div>}
            <iframe title={t('DEVLOPMENT_ORDER.PURCHASE_ORDER_DOCUMENT.PREVIEW_MODAL.PREVIEW_FRAME')} className="w-100 preview-modal-height" src={data?.path} />
            <div className="modal-buttons mt-2 d-flex justify-content-between">
              <button className="btn btn-default" type="button" onClick={() => toggle()}>
                {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.PREVIEW_MODAL.CLOSE')}
              </button>
            </div>
          </Modal.Body>
        </Modal>
      )}
      {data?.mimeType === 'application/msword' && (
        <Modal className={MODAL_CLASS_NAMES} size={MODAL_SIZE} show={onOpen} onHide={toggle} backdrop={MODAL_BACKDROP} centered={MODAL_CENTERED}>
          <Modal.Header>
            {data?.fileName}
            <button type="button" className="close" onClick={toggle} aria-label={t('COMMON_LABEL.CLOSE')}>
              <i className="icon-close" />
            </button>
          </Modal.Header>
          <Modal.Body className="px-5">
            <IframeDocxPreview docxUrl={data?.path} />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}

export default PreviewModal;
